/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierDocumentType } from "./CarrierDocumentType";
import {
  CarrierDocumentTypeFromJSON,
  CarrierDocumentTypeFromJSONTyped,
  CarrierDocumentTypeToJSON,
  CarrierDocumentTypeToJSONTyped,
} from "./CarrierDocumentType";

/**
 *
 * @export
 * @interface CarrierDocumentDataFromHubble
 */
export interface CarrierDocumentDataFromHubble {
  /**
   *
   * @type {string}
   * @memberof CarrierDocumentDataFromHubble
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocumentDataFromHubble
   */
  description?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CarrierDocumentDataFromHubble
   */
  dateReceived?: LocalDate | null;
  /**
   *
   * @type {boolean}
   * @memberof CarrierDocumentDataFromHubble
   */
  isCurrent: boolean;
  /**
   *
   * @type {CarrierDocumentType}
   * @memberof CarrierDocumentDataFromHubble
   */
  documentType: CarrierDocumentType;
  /**
   *
   * @type {string}
   * @memberof CarrierDocumentDataFromHubble
   */
  documentData: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocumentDataFromHubble
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocumentDataFromHubble
   */
  contentType: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierDocumentDataFromHubble
   */
  isSigned: boolean;
}

/**
 * Check if a given object implements the CarrierDocumentDataFromHubble interface.
 */
export function instanceOfCarrierDocumentDataFromHubble(
  value: object,
): value is CarrierDocumentDataFromHubble {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("isCurrent" in value) || value["isCurrent"] === undefined) return false;
  if (!("documentType" in value) || value["documentType"] === undefined)
    return false;
  if (!("documentData" in value) || value["documentData"] === undefined)
    return false;
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("isSigned" in value) || value["isSigned"] === undefined) return false;
  return true;
}

export function CarrierDocumentDataFromHubbleFromJSON(
  json: any,
): CarrierDocumentDataFromHubble {
  return CarrierDocumentDataFromHubbleFromJSONTyped(json, false);
}

export function CarrierDocumentDataFromHubbleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierDocumentDataFromHubble {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    dateReceived:
      json["dateReceived"] == null ? undefined : json["dateReceived"],
    isCurrent: json["isCurrent"],
    documentType: CarrierDocumentTypeFromJSON(json["documentType"]),
    documentData: json["documentData"],
    carrierIdentifier: json["carrierIdentifier"],
    contentType: json["contentType"],
    isSigned: json["isSigned"],
  };
}

export function CarrierDocumentDataFromHubbleToJSON(
  json: any,
): CarrierDocumentDataFromHubble {
  return CarrierDocumentDataFromHubbleToJSONTyped(json, false);
}

export function CarrierDocumentDataFromHubbleToJSONTyped(
  value?: CarrierDocumentDataFromHubble | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    description: value["description"],
    dateReceived: value["dateReceived"],
    isCurrent: value["isCurrent"],
    documentType: CarrierDocumentTypeToJSON(value["documentType"]),
    documentData: value["documentData"],
    carrierIdentifier: value["carrierIdentifier"],
    contentType: value["contentType"],
    isSigned: value["isSigned"],
  };
}
